export function anchorScroll(anchor) {
    document.querySelector(anchor).scrollIntoView({
        behavior: 'smooth'
    });
}